import {
  type GenericDetailQueryKey,
  type GenericListQueryKey,
  generateDetailQueryKey,
  generateInfiniteQueryKey,
  generateListQueryKey,
} from '@pba/react-query';

type ContentObjectsListQuery = GenericListQueryKey<ContentObjectsQueryFilter>;

type ContentObjectsQueryFilter = {
  communityId?: string;
  groupId?: string;
  pinned?: boolean;
  programId?: string;
  programTopicId?: string;
};

export const getContentObjectFeatureKey = () => ['content-object'] as const;

export const getContentObjectsListQueryKey = (params: ContentObjectsListQuery) =>
  generateListQueryKey({
    prefix: getContentObjectFeatureKey(),
  })(params);

export const getContentObjectsInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getContentObjectsListQueryKey,
});

export const getContentObjectDetailQueryKey = (params: GenericDetailQueryKey) =>
  generateDetailQueryKey({
    prefix: getContentObjectFeatureKey(),
  })(params);

export const getPublicContentObjectDetailQueryKey = (params: GenericDetailQueryKey) =>
  generateDetailQueryKey({
    prefix: [...getContentObjectFeatureKey(), 'public'],
  })(params);

export const getContentObjectRepliesQueryKey = (params: GenericDetailQueryKey) =>
  generateDetailQueryKey({
    prefix: [...getContentObjectFeatureKey(), 'replies'],
  })(params);
